import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
    Data,
    ActivatedRoute,
    NavigationCancel,
    NavigationEnd,
    NavigationStart,
    Params,
    PRIMARY_OUTLET,
    Router,
} from "@angular/router";
import * as _ from "lodash";
import { BehaviorSubject } from "rxjs";
import { Location } from "@angular/common";
import { distinctUntilChanged, filter, map, tap } from "rxjs/operators";

@Component({
    selector: "nbc-breadcrumb",
    templateUrl: "./nbc-breadcrumb.component.html",
    standalone: false
})
export class NbcBreadcrumbComponent implements OnInit, OnDestroy {
    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) {}

    // Build your breadcrumb starting with the root route of your current activated route
    breadcrumbs$: any;
    newBreadcrumbs_: any;

    buildBreadCrumb(
        route: ActivatedRoute,
        url = "",
        breadcrumbs: Array<BreadCrumb> = []
    ): Array<BreadCrumb> {
        // If no routeConfig is avalailable we are on the root path
        const label = route.routeConfig
            ? _.get(route.routeConfig, "data.breadcrumb")
            : "Home";
        const path = route.routeConfig ? route.routeConfig.path : "";
        // In the routeConfig the complete path is not available,
        // so we rebuild it each time

        const nextUrl = `${url}${path}/`;
        const breadcrumb = {
            label: label,
            url: nextUrl,
        };
        let tempStorage = [];
        if (label === "Template Details") {
            let templateUrl = `${url}$`;
            templateUrl = _.dropRight(templateUrl.split("/"), 2).join("/");
            const breadcrumb_temp = {
                label: "Templates",
                url: templateUrl || "../../../list",
            };
            tempStorage = [...breadcrumbs, ...tempStorage, breadcrumb_temp];
        }
        tempStorage = [...breadcrumbs, ...tempStorage, breadcrumb];

        const newBreadcrumbs = [
            ...new Map(
                tempStorage.map((item) => [item["label"], item])
            ).values(),
        ];

        if (route.firstChild) {
            // If we are not on our current path yet,
            // there will be more children to look after, to build our breadcumb
            return this.buildBreadCrumb(
                route.firstChild,
                nextUrl,
                newBreadcrumbs
            );
        }
        this.newBreadcrumbs_ = newBreadcrumbs.filter(
            (breadcrumb) =>
                breadcrumb.label != "dashboard" && breadcrumb.label != undefined
        );
        return newBreadcrumbs;
    }

    ngOnInit() {
        const homeLink: Array<BreadCrumb> = [];
        homeLink.push({ label: "Home", url: "/dashboard" });
        this.buildBreadCrumb(this.activatedRoute, "", homeLink);
    }

    ngOnDestroy(): void {
        //this.buildBreadCrumb(this.activatedRoute);
    }
}

export class BreadCrumb {}
